import React from "react"
import Icon from "../../icons/Icon"
import { IconLibrary } from "../../../../interfaces/icon/IconLibrary"



function getIconColor(type: 'info' | 'warning' | 'error') {
    switch (type) {
        case 'info':
            return 'var(--thriveCharcoal)';
        case 'warning':
        case 'error':
            return 'var(--thriveRed)'
    }
}

const InformationContainer = ({type='info',className,  children}: {type: 'info' | 'warning' | 'error', className?: string, children: React.JSX.Element}) => {
    return (
        <div className={`thrive-components-information-container ${className ? className : ''}`}>
            <div className={`icon-wrapper ${type}`}>
                <Icon iconName={IconLibrary.INFO} color={getIconColor(type)} sizeInPx="12"/>
            </div>
            <div className="message-wrapper">
                {children}
            </div>
        </div>
    )
}

export default InformationContainer;